import { useEffect, useRef } from "react";

const WaterRipple = () => {
  const canvasRef = useRef(null);
  let ripples = [];

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resize();
    window.addEventListener("resize", resize);

    const createRipple = (x, y) => {
      ripples.push({
        x,
        y,
        radius: 0,
        alpha: 0.5,
      });
    };

    const handleMove = (e) => {
      createRipple(e.clientX, e.clientY);
    };

    window.addEventListener("mousemove", handleMove);

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ripples.forEach((r, index) => {
        ctx.beginPath();
        ctx.arc(r.x, r.y, r.radius, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(255,255,255,${r.alpha})`;
        ctx.lineWidth = 2;
        ctx.stroke();

        r.radius += 2;
        r.alpha -= 0.01;

        if (r.alpha <= 0) {
          ripples.splice(index, 1);
        }
      });

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} className="ripple-canvas"></canvas>;
};

export default WaterRipple;